import '../simple-portable-text/simple-portable-text.css';
import '../../styles/carl-typography.css';
import '../../components/blog/blog-typography.module.css';

import classNames from 'classnames';
import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';

import * as blogTypography from '../../components/blog/blog-typography.module.css';
import { BarebonesPortableText } from '../barebones-portable-text/barebones-portable-text';
import { IterableEmbed } from '../iterableEmbed';
import { Lottie } from '../lottie';
import { MainImage } from '../mainImage';
import { ProviderProfiles } from '../provider-profiles';
import { SimplePortableText } from '../simple-portable-text/simple-portable-text';
import { BlogPostCta } from './blog-post-cta';
import { BlogVideoEmbed } from './blog-video-embed';
import * as styles from './serializers.module.css';

const AuthorReference = ({ node }) => {
	if (node.author?.name) {
		return <span>{node.author.name}</span>;
	}
	return null;
};

const Tip = ({ text }) => {
	return (
		<SimplePortableText blocks={text} className={classNames(styles.tip)} />
	);
};

const Divider = () => {
	return (
		<hr
			style={{
				margin: '2rem auto',
				color: 'var(--grey-300)',
				height: '1px',
			}}
		/>
	);
};

const Quote = ({ author, link, quote, source, featuredQuote }) => {
	return (
		<figure
			className={classNames(
				styles.quoteText,
				featuredQuote && styles.quoteFeatured
			)}
		>
			<blockquote>
				<BarebonesPortableText
					blocks={quote}
					className={styles.blockQuote}
				/>
			</blockquote>

			{source ? (
				<figcaption className={classNames('body-sm-caps', 'cdgr')}>
					&mdash;{' '}
					{link ? (
						<a
							target='_blank'
							rel='noopener noreferrer'
							href={link}
						>
							{source}
						</a>
					) : (
						source
					)}
				</figcaption>
			) : author ? (
				<figcaption className={classNames('body-sm-caps', 'cdgr')}>
					&mdash;{' '}
					<a href={`/blog/authors/${author.slug?.current}/`}>
						{author.name}
					</a>
					{author.specialty && `, ${author.specialty}`}
				</figcaption>
			) : null}
		</figure>
	);
};

export const serializers = {
	types: {
		anchorDestination: ({ node }: { node: any }) => {
			const { anchorLinkId } = node;
			return (
				<span
					className={classNames(
						styles.anchorDestination,
						blogTypography.anchorDestination
					)}
					id={anchorLinkId}
				></span>
			);
		},
		authorReference: AuthorReference,
		blogPostCta: ({ node }: { node: any }) => <BlogPostCta {...node} />,
		callout: ({ node }: { node: any }) => (
			<aside className={styles.callout}>
				<BarebonesPortableText
					blocks={node.text}
					className={styles.callout}
				/>
			</aside>
		),
		divider: Divider,
		instagram: ({ node }: { node: any }) => {
			if (!node.url) return null;
			const instagramEmbedProps: any = {
				url: node.url,
				style: {
					maxWidth: 540,
					minWidth: 327,
				},
				width: '100%',
			};

			if (node.hasCaption) {
				instagramEmbedProps.captioned = true; // or you can use a variable if needed
			}

			return (
				<div className={styles.instagramEmbedContainer}>
					<InstagramEmbed {...instagramEmbedProps} />
				</div>
			);
		},
		iterableForm: ({ node }: { node: any }) => (
			<IterableEmbed iterableForm={node} />
		),
		lottieAnimation: ({ node }: { node: any }) => <Lottie {...node} />,
		mainImage: ({ node }: { node: any }) => <MainImage mainImage={node} />,
		providerProfilesSearch: ({ node }: { node: any }) => (
			<ProviderProfiles {...node} />
		),
		quote: ({ node }: { node: any }) => <Quote {...node} />,
		tip: ({ node }: { node: any }) => <Tip {...node} />,
		videoEmbed: ({ node }: { node: any }) => (
			<BlogVideoEmbed className={styles.videoEmbed} {...node} />
		),
	},
	marks: {
		link: ({ children, mark }) => {
			const openInNewTab = mark.openInNewTab === true;
			return (
				<a
					target={openInNewTab ? '_blank' : '_self'}
					rel={openInNewTab ? 'noopener noreferrer' : undefined}
					href={mark.href}
				>
					{children}
				</a>
			);
		},
		fontAdjustments: ({ children }) => {
			console.log('Unknown mark - fontAdjustments: ', children);
		},
	},
};
